import { developers4S } from "../projects/4s/data";
import { developersM3M } from "../projects/M3M/data";
import { developersBirla } from "../projects/Birla/data";
import { developersConscient } from "../projects/Conscient/data";
import { developersDLF } from "../projects/DLF/data";
import { developersEldeco } from "../projects/eldeco/data";
import { developersMax } from "../projects/max/data";
import { developersSignatureGlobal } from "../projects/signatureglobal/data";
import { developersSilverGlades } from "../projects/silverglades/data";
import { developersSmartworld } from "../projects/smartworld/data";
import { developersSobha } from "../projects/sobha/data";
import { developersTarc } from "../projects/Tarc/data"
import { developersWhiteland } from "../projects/whiteland/data";
import { developersShapoorji } from '../projects/ShapoorjiPaloonji/data';
import { developersMahindra } from "../projects/mahindra/data"
import { developersBrigade } from "../projects/Brigade/data";
// import { developersCasagrand } from "../projects/casagrand/data";
import { developersEktaworld } from "../projects/ekta/data";
import { developersHiranandani } from "../projects/Hiranandani-Group/data";
import { developersKalpataru } from "../projects/kalpataru/data";
import { developerKolte } from "../projects/kolte/data";
import { developersRustomjee } from "../projects/Rustomjee/data";
import { developersSattva } from "../projects/sattva/data";
import { developersPuravankara } from "../projects/puravankara/data";
import { developersMantra } from "../projects/Mantra/data";
import { developersMantri } from "../projects/mantri/data";
export const allProjectData = [
  ...developers4S.properties,
  ...developersM3M.properties,
  ...developersBirla.properties,
  ...developersConscient.properties,
  ...developersDLF.properties,
  ...developersEldeco.properties,
  ...developersMax.properties,
  ...developersSignatureGlobal.properties,
  ...developersSilverGlades.properties,
  ...developersSmartworld.properties,
  ...developersSobha.properties,
  ...developersTarc.properties,
  ...developersWhiteland.properties,
  ...developersShapoorji.properties,
  ...developersMahindra.properties,
  ...developersBrigade.properties,
  // ...developersCasagrand.properties,
  ...developersEktaworld.properties,
  ...developersHiranandani.properties,
  ...developerKolte.properties,
  ...developersKalpataru.properties,
  ...developersRustomjee.properties,
  ...developersSattva.properties,
  ...developersPuravankara.properties,
  ...developersMantra.properties,
  ...developersMantri.properties,


];